export default __webpack_public_path__ + "2585d71caf91af5a62f0ad1ed8d25892.svg";